import { createContext } from "react";

export const ContextHistoryStock = createContext(null);
